import { UserRoles } from '@dynamika-shared/types/auth';
import { Option } from '@utils/generateOptions';
import { rolesMap } from 'src/constants/rolesList';

export const mapRolesToOptions = (
  roles: (UserRoles | undefined)[]
): Option[] => {
  return roles
    .filter(role => role !== undefined)
    .map(role => rolesMap[role as UserRoles]);
};
